import React from "react";
import Landing from "./components/Landing/Landing";
import Dashboard from "./components/Dashboard";
import Auth from "./components/Auth";
import Story from "./components/Story/Show";
import Episode from "./components/Episode/Episode";
import User from "./components/User/User";
import StoryCreate from "./components/Story/Create";
import EpisodeCreate from "./components/Episode/Create";
import Browse from "./components/Browse/Browse";
import BrowseByAuthor from "./components/User/BooksByAuthor";
import Terms from "./components/Static/Terms";
import EditUser from "./components/User/EditUser";
import Checkout from "./components/Premium/Checkout";
import OrderHistory from "./components/Premium/OrderHistory";
import PremiumPackets from "./components/Premium/PremiumPackets";

export const routes = {
  "/": () => <Dashboard />,
  "/story/new": () => <StoryCreate />,
  "/story/:id": ({ id }) => <Story storyID={id} />,
  "/mystory/:id": ({ id }) => <Story storyID={id} myStory={true} />,
  "/episode/new/:storyID": ({ storyID }) => <EpisodeCreate storyID={storyID} />,
  "/episode/:storyID/:episodeID": ({ storyID, episodeID }) => (
    <Episode storyID={storyID} episodeID={episodeID} />
  ),
  "/myepisode/:storyID/:episodeID": ({ storyID, episodeID }) => (
    <Episode storyID={storyID} episodeID={episodeID} myStory={true} />
  ),
  "/episode/update/:storyID/:episodeID": ({ storyID, episodeID }) => (
    <EpisodeCreate storyID={storyID} episodeID={episodeID} />
  ),
  "/user": () => <User />,
  "/user/edit": () => <EditUser />,
  "/user/orders": () => <OrderHistory />,
  "/user/:id": ({ id }) => <User id={id} />,
  "/terms": () => <Terms title={"terms"} />,
  "/privacy": () => <Terms title={"privacy"} />,
  "/browse/byAuthor/:author": ({ author }) => (
    <BrowseByAuthor author={decodeURIComponent(author)} />
  ),
  "/browse/:type/:term": ({ term, type }) => (
    <Browse term={decodeURIComponent(term)} type={decodeURIComponent(type)} key={term}/>
  ),
  "/checkout/:token": ({ token }) => (<Checkout token={token} />),
  "/premium/packets": () => <PremiumPackets />
};

export const guestRoutes = {
  "/": () => <Landing />,
  "/login": () => <Auth />,
  "/register": () => <Auth type={"create"} />,
  "/reset/send": () => <Auth type={"resetSend"} />,
  "/reset/:code": ({ code }) => <Auth type={"reset"} code={code} />,
  "/reset": () => <Auth type={"reset"} />,
  "/verify": () => <Auth type={"verify"} />,
};
